export const topPlayerDependencies = (player) => {
  const { model: playerModel, config: playerConfig } = player
  
  return {
    playerInstance: player,
    playerVendor: 'TOP2',
    getCDN: () => playerModel.playlistItem?.entry?.metadata?.cdnType,
    currentVideoPosition: () => playerModel.mediaTime,
    currentMediaState: () => playerModel.mediaState,
    getVideoDurationSec: () => playerModel.mediaDuration,
    getStreamHost: () => playerModel.config?.metadata?.cdnHost,
    getStreamUrl: () => playerModel.playlistItem?.entry?.files?.[0]?.url,
    getAutoplay: () => playerConfig.playback?.autoPlay,
    getStreamType: () => playerModel.contentIsLive ? 'Live' : 'VOD',
    getLiveStreamName: () => playerModel.playlistItem?.entry?.id,
  }
}
